import BooleanLabel from './BooleanLabel';

export default BooleanLabel;
